module.exports = __webpack_public_path__ + "img/ClickForSound_29.368e26ff.png";